import React from "react";
import { Link } from "react-router-dom";
import back from "../../assets/service-images/managedbackround.webp";
import tick from "../../assets/service-images/tick.png";
import image1 from "../../assets/service-images/Line001.png";
import image from "../../assets/service-images/Frame1000005910.webp";
import image2 from "../../assets/service-images/Frame1000005911.svg";
import image3 from "../../assets/service-images/Frame1000005912.svg";
import image4 from "../../assets/service-images/Frame1000005913.svg";
import image5 from "../../assets/service-images/Frame1000005914.svg";
import image6 from "../../assets/service-images/Frame1000005915.svg";
import image7 from "../../assets/service-images/Frame1000005916.svg";

const ManagedService = () => {
  return (
    <>
      {/* Section 1 */}
      <div
        className="bg-cover bg-center bg-no-repeat min-h-[502px] flex flex-col gap-8 justify-start px-6 py-16 md:px-8 lg:px-16"
        style={{ backgroundImage: `url(${back})` }}
      >
        <h1
          data-aos="fade-down"
          className="text-2xl md:text-3xl lg:text-3xl xl:text-5xl font-bold text-white w-full md:w-2/3 lg:w-2/5 xl:w-[747px]"
        >
          Always-on support, tailored to your needs.
        </h1>
        <p
          data-aos="fade-down"
          className="text-white text-base w-full md:w-2/3 lg:w-2/2 xl:w-[680px]"
        >
          Tekpossible partners with you to maximize your Service now ROI. We
          blend business and technical expertise with flexible programs,
          providing support, maintenance, enablement, and advisement throughout
          your platform journey.
        </p>
        <Link
          data-aos="zoom-in"
          data-aos-delay="300"
          to="/contact-us"
          className="w-[100px] w-fit sm:w-[150px] md:w-[140px] lg:w-[150px] bg-[#C32A7C] px-5 py-2 sm:px-6 sm:py-2.5 lg:px-0 lg:py-2 rounded-lg text-white  hover:bg-white hover:text-[#C32A7C] transition-colors duration-300 text-sm sm:text-sm md:text-sm lg:text-lg text-center whitespace-nowrap"
        >
          Contact Us
        </Link>
      </div>

      {/* Section 2 */}
      <div className="flex flex-col lg:flex-row items-center justify-between px-6 py-16 md:px-8 lg:px-16 gap-10">
        <div className="flex flex-col items-start w-full lg:w-1/2">
          <img
            src={image1}
            alt="Illustration"
            className="max-w-xs md:max-w-sm"
            data-aos="fade-up"
            data-aos-delay="300"
          />
          <h1
            className="text-black font-semibold text-2xl md:text-2xl mt-5 w-full lg:w-[600px]"
            data-aos="fade-up"
            data-aos-delay="300"
          >
            Our managed services can provide you the solution If…
          </h1>
          <ul
            className="mt-5 space-y-3"
            data-aos="fade-up"
            data-aos-delay="300"
          >
            {[
              "Looking for extra support during your ServiceNow Go-Live or for your new admin?",
              "Our expertise ensures your platform is configured to support your specific business needs.",
              "We provide expert ServiceNow maintenance support.",
              "Your goal is to maximize ROI, and we can help you build a roadmap to prioritize the activities and requests that will achieve it.",
              "Empower your ServiceNow teams to be proactive by reducing backlogs through effective maintenance",
            ].map((item, index) => (
              <li
                key={index}
                className="flex text-black items-center gap-4 text-sm md:text-base"
              >
                <img src={tick} alt="Tick" className="w-5 h-5" />
                <span>{item}</span>
              </li>
            ))}
          </ul>
        </div>

        <div
          className="flex justify-center lg:justify-end w-full lg:w-1/2"
          data-aos="fade-up"
          data-aos-delay="300"
        >
          <img
            className="w-48 h-48 md:w-56 md:h-56 lg:w-[480px] lg:h-[430px]"
            src={image}
            alt="Technical Illustration"
          />
        </div>
      </div>

      {/* Section 3 */}
      <div className="flex flex-col justify-start px-4 py-8 md:py-12 lg:py-16 bg-[#F0FAFF]">
        <div className="relative">
          <div className="text-center mb-10 px-6">
            <h1
              className="text-black font-semibold text-2xl lg:text-3xl"
              data-aos="fade-up"
            >
              How Clients Are Using Our Managed Services
            </h1>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-3 px-6 gap-3 py-5">
            {[
              {
                img: image2,
                title: "Administration & Maintenance",
                desc: "Our administration services cover all aspects of your email, form, data, and report management.",
              },
              {
                img: image3,
                title: "Integrations",
                desc: "Our integration solutions are designed with efficiency and maintainability in mind, supporting connections with hundreds of services. We also provide expert advice on integrated monitoring and troubleshooting for your API integrations.",
              },
              {
                img: image4,
                title: "Guidance",
                desc: "We support your team with expert guidance on best practices, enabling them to effectively review metrics, interpret ServiceNow data, refine ROIs, navigate ServiceNow apps/modules, and prepare for OCM readiness.",
              },
              {
                img: image5,
                title: "Training",
                desc: "Our training is tailored to your needs, with options ranging from personalized 1:1 or group mentoring to custom training guide development and comprehensive business process support.",
              },
              {
                img: image6,
                title: "We identify",
                desc: "diagnose, and resolve issues, providing estimates for the necessary remediation and implementing the fixes.",
              },
              {
                img: image7,
                title: "Ongoing Enhancements",
                desc: "We empower your team to be proactive with maintenance and enhancements through expert technical support from our certified technicians.",
              },
            ].map((service, index) => (
              <div
                data-aos="fade-up"
                key={index}
                className="sec3 flex flex-col items-center text-center mt-20 transform transition-all duration-300 hover:scale-105 hover:shadow-xl"
              >
                <div className="w-full bg-gradient-to-r from-[#981A59] to-[#124B6A] h-[10px]"></div>
                <div className="flex flex-col items-center rounded border bg-[#FFFFFF] flex-1 w-full hover:transition-all duration-300">
                  <img
                    className="-mt-10 transform transition-transform duration-300"
                    src={service.img}
                    alt={service.title}
                  />
                  <h3 className="sec3title text-lg font-semibold mt-4 text-[#000]">
                    {service.title}
                  </h3>
                  <p className="text-sm text-black mt-2 flex-grow lg:w-[300px] mb-10">
                    {service.desc}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Section 4 */}

      <div className="bg-[#FFFFFF] w-full py-8 md:py-16 mt-6">
        <div
          className="flex flex-col items-center text-center px-4 md:px-6"
          data-aos="fade-down-right"
        >
          {/* Heading */}
          <h1 className="text-[#1A5298] font-bold text-xl md:text-2xl lg:text-4xl text-center mb-8 w-full md:w-2/3 lg:w-2/3 xl:w-2/3">
            Access the support you need for ServiceNow success, every step of
            the way
          </h1>

          {/* Button */}
          <Link
            data-aos="zoom-in"
            data-aos-delay="300"
            to={"/contact-us"}
            className="w-[140px] px-6 py-2 md:px-4 md:py-2.5 bg-[#C32A7C] rounded-lg text-white font-bold 
                                         hover:bg-[#F6F6F6] hover:text-[#C32A7C] transition-colors duration-300 text-sm md:text-base 
                                         text-center whitespace-nowrap mt-4 border border-[#C32A7C]"
          >
            Contact us
          </Link>
        </div>
      </div>
    </>
  );
};

export default ManagedService;
